import { MenuItem } from 'components/shared/LocalMenu/menuItems';
import { Link, useLocation } from 'react-router-dom';
import urls from 'routes/urls';
import { useLanguage } from 'hooks/Language/useLanguage';
import { useEffect, useState } from 'react';
import { Tooltip } from 'antd';

import {
  // CreditCard,
  // HandCoins,
  History,
  House,
  ReceiptText,
  SquareUser,
  Users,
  WalletCards,
  UsersRound,
  Building2,
  LockKeyhole,
} from 'lucide-react';

export const useLeftNavBarItems = (
  isOrganization = false,
  cashPointLogedIn = 'NO',
  accountPending = false,
): MenuItem[] => {
  const { translate } = useLanguage();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  // While the bank account is being opened, account-dependent entries stay
  // visible (so users see what is coming) but are locked, not links.
  const navItem = (
    key: string,
    icon: React.ReactNode,
    path: string,
    label: string,
    lockable = false,
  ): MenuItem =>
    lockable && accountPending
      ? {
          key,
          icon,
          label: (
            <Tooltip
              title={translate('Unlocks once your account is opened')}
              placement="right"
            >
              <span className="nav-link nav-link-locked">
                {translate(label)}
                <LockKeyhole size={14} strokeWidth={2.2} />
              </span>
            </Tooltip>
          ),
          className: 'nav-item nav-item-locked',
        }
      : {
          key,
          icon,
          label: (
            <Link to={path} className="nav-link">
              {translate(label)}
            </Link>
          ),
          className: isActive(path) ? 'nav-item-active' : 'nav-item',
        };

  const menuItems: MenuItem[] = [
    navItem(
      '1',
      <House size={22} strokeWidth={2} />,
      urls.dashboard,
      'Home',
      false,
    ),
    navItem(
      '2',
      <WalletCards size={22} strokeWidth={2} />,
      urls.accounts,
      'Accounts',
      true,
    ),
    navItem(
      '3',
      <History size={22} strokeWidth={2} />,
      urls.transactions,
      'Transactions',
      true,
    ),
    navItem(
      '4',
      <ReceiptText size={22} strokeWidth={2} />,
      urls.payBills,
      'Pay Bills',
      true,
    ),
    /*
    {
      key: '5',
      icon: <CreditCard size={22} strokeWidth={2} />,
      label: (
        <Link to="#" className="nav-link nav-link-disabled">
          {translate('Cards')}
        </Link>
      ),
      className: 'nav-item nav-item-disabled',
    },
    */
    navItem(
      '6',
      <Users size={22} strokeWidth={2} />,
      urls.beneficiary,
      'Beneficiaries',
      true,
    ),
    /*
    {
      key: '7',
      icon: <HandCoins size={22} strokeWidth={2} />,
      label: (
        <Link to="#" className="nav-link nav-link-disabled">
          {translate('Loans')}
        </Link>
      ),
      className: 'nav-item nav-item-disabled',
    },
    */
    // Only show Organization on desktop when isOrganization is true
    isOrganization && !isMobile
      ? {
          key: '8',
          icon: <Building2 size={22} strokeWidth={2} />,
          label: (
            <Link to={urls.organization} className="nav-link">
              {translate('Organization')}
            </Link>
          ),
          className: isActive(urls.organization)
            ? 'nav-item-active'
            : 'nav-item',
        }
      : null,
    navItem(
      '9',
      <SquareUser size={22} strokeWidth={2} />,
      urls.userProfile,
      'Profile',
      false,
    ),
  ];

  if (cashPointLogedIn === 'YES') {
    menuItems.push({
      key: '10',
      icon: <UsersRound size={22} strokeWidth={2} />,
      label: (
        <Link to={urls.tellers} className="nav-link">
          {translate('Tellers')}
        </Link>
      ),
      className: isActive(urls.tellers)
        ? 'nav-item-active'
        : 'nav-item',
    });
  }

  return menuItems.filter((item) => item !== null);
};
